// Mega Menu Image Code

let megaMenuImageEl = document.getElementById("megaMenuImage");
let defaultImage = megaMenuImageEl ? megaMenuImageEl.src : null;

function updateMegaMenuImage(imageUrl) {
  let imageElement = document.getElementById("megaMenuImage");
  if (!imageElement) return;
  if (imageUrl && imageUrl !== "null") {
    imageElement.src = imageUrl;
  }
}

function resetMegaMenuImage() {
  let imageElement = document.getElementById("megaMenuImage");
  if (!imageElement || !defaultImage) return;
  imageElement.src = defaultImage;
}

